// External Dependencies
import PropTypes from 'prop-types';
import React from 'react';

// Internal Dependencies

// Local Variables
const propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.shape(),
};

const defaultProps = {
  style: null,
};

// Styles
const rootStyles = {
  alignItems: 'center',
  display: 'flex',
  fontSize: 20,
  lineHeight: '30px',
  padding: '16px 24px',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  zIndex: 100,
};

// Component Definition
const Title = (props) => {
  const {
    children,
    style,
  } = props;

  const titleStyles = style
    ? { ...rootStyles, ...style }
    : rootStyles;

  return (
    <div style={titleStyles}>{children}</div>
  );
};

Title.propTypes = propTypes;
Title.defaultProps = defaultProps;
export default Title;



/** WEBPACK FOOTER **
 ** ./src/shared/title/index.js
 **/